// src/api/http.ts
import axios from 'axios'
import { authStore } from '../store/auth'

// ✅ สร้าง instance ของ axios
export const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3030',
  timeout: 10000,
})

console.log('API BASE URL =', process.env.REACT_APP_API_BASE_URL)
// ✅ interceptor สำหรับแนบ token
http.interceptors.request.use((config) => {
  const token = authStore.token
  if (token) {
    config.headers = config.headers ?? {};
    (config.headers as any).Authorization = `Bearer ${token}`
  }
  return config
})
